import React, { useEffect, useMemo, useRef } from 'react';

import { Nomenclature } from '@feature/nomenclature';

export function useNoOp() {
  // do nothing
}

export function useEffectOnce(cb: () => void, condition = true) {
  const isCalledRef = React.useRef(false);

  React.useEffect(() => {
    if (condition && !isCalledRef.current) {
      isCalledRef.current = true;
      cb();
    }
  }, [cb, condition]);
}

export function usePrevious<T>(value: T, initialValue?: T) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef<T | null>(initialValue ?? null);
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

export function useSortedNomen(data: Nomenclature[] | undefined, type: 'DESC' | 'ASC') {
  return useMemo(() => {
    const arr = [...(data ?? [])];

    return arr.sort((a, b) => {
      if (a.name < b.name) {
        return type === 'DESC' ? 1 : -1;
      }
      if (a.name > b.name) {
        return type === 'DESC' ? -1 : 1;
      }
      return 0;
    });
  }, [data, type]);
}

export * from './useDelete';
export * from './useAppNotification';
